<template>
  <div v-if="manifestation && (canSee || otherRecords.length)" class="manifestation-section">
    <!-- Manifestação da outra parte (ex.: a Recuperanda sobre a CHC do credor), somente leitura. -->
    <div v-for="record in otherRecords" :key="`${record.party}-${record.registration}`" class="manifestation-box">
      <div class="d-flex align-center flex-wrap">
        <v-icon small color="blue-grey" class="mr-2">mdi-message-reply-text-outline</v-icon>
        <span class="text-subtitle-2 font-weight-bold mr-3">Manifestação da {{ record.party === 'debtor' ? 'Recuperanda' : 'parte' }}</span>
        <v-chip x-small label :color="color(record.status)" text-color="white">{{ record.status_label }}</v-chip>
      </div>
      <ManifestationFields :record="record" />
    </div>

    <!-- Manifestação do credor (quando cabe a ele). -->
    <template v-if="canSee">
      <div v-if="mine" class="manifestation-box">
        <div class="d-flex align-center flex-wrap">
          <v-icon small color="primary" class="mr-2">mdi-message-reply-text-outline</v-icon>
          <span class="text-subtitle-2 font-weight-bold mr-3">{{ lawyer ? 'Manifestação do credor' : 'Sua manifestação' }}</span>
          <v-chip x-small label :color="color(mine.status)" text-color="white">{{ mine.status_label }}</v-chip>
          <v-spacer />
          <v-btn v-if="canEdit" small text color="primary" @click="dialog = true"><v-icon left small>mdi-pencil</v-icon>Alterar</v-btn>
        </div>
        <ManifestationFields :record="mine" />
      </div>
      <div v-else-if="manifestation.can_manifest" class="manifestation-box manifestation-box--pending">
        <div class="d-flex align-center flex-wrap">
          <div class="mr-4">
            <div class="text-subtitle-2 font-weight-bold">{{ lawyer ? 'O credor pode se manifestar' : 'Você pode se manifestar' }} sobre {{ subjectLabel }}</div>
            <div class="text-body-2">Prazo até <strong>{{ $moment(manifestation.deadline_at).format('DD/MM/YYYY') }}</strong>.</div>
          </div>
          <v-spacer />
          <v-btn v-if="moduleOpen" color="primary" elevation="0" class="mt-2 mt-sm-0" @click="dialog = true">
            <v-icon left small>mdi-message-reply-text-outline</v-icon>Manifestar-se
          </v-btn>
        </div>
        <div v-if="!moduleOpen" class="text-body-2 mt-2">{{ $modules.message(moduleKey) }}</div>
      </div>
      <div v-else class="manifestation-box text-body-2 grey--text text--darken-1">{{ closedMessage }}</div>
      <ManifestationDialog v-model="dialog" :endpoint="endpoint" :mine="mine" :deadline="manifestation.deadline_at"
        :overline="overline" :question="question" :registration="registration" @saved="onSaved" />
    </template>
  </div>
</template>

<script>
import ManifestationDialog from './ManifestationDialog.vue';
import ManifestationFields from './ManifestationFields.vue';

// Manifestação (contraditório) do credor e da Recuperanda em CHCs e comprovantes (site).
export default {
  name: 'ManifestationSection',
  components: { ManifestationDialog, ManifestationFields },
  props: {
    manifestation: { type: Object, default: null },
    endpoint: { type: String, required: true },
    moduleKey: { type: String, required: true },
    subjectLabel: { type: String, default: 'este item' },
    overline: { type: String, default: '' },
    question: { type: String, default: 'Você concorda?' },
    lawyer: { type: Boolean, default: false },
    registration: { type: String, default: null },
  },
  data: () => ({ dialog: false }),
  computed: {
    canSee() { return !!this.manifestation && this.manifestation.expected_party === 'creditor'; },
    mine() { return this.manifestation ? this.manifestation.mine : null; },
    otherRecords() { return ((this.manifestation && this.manifestation.records) || []).filter(record => record.party !== 'creditor'); },
    moduleOpen() { return this.$modules.isOpen(this.moduleKey); },
    canEdit() { return !!this.manifestation && this.manifestation.can_manifest && this.moduleOpen; },
    closedMessage() {
      const deadline = this.manifestation && this.manifestation.deadline_at;
      if (deadline && this.$moment().isAfter(deadline)) return `O prazo para manifestação terminou em ${this.$moment(deadline).format('DD/MM/YYYY')}.`;
      return 'A manifestação não está mais disponível para este item.';
    },
  },
  methods: {
    color(status) { return { 1: 'green darken-1', 2: 'red darken-1', 3: 'indigo' }[Number(status)] || 'blue-grey'; },
    onSaved(record) {
      this.$set(this.manifestation, 'mine', record);
      const others = (this.manifestation.records || []).filter(item => !(item.party === record.party && item.registration === record.registration));
      this.$set(this.manifestation, 'records', [...others, record]);
      this.$dialog.notify.success('Manifestação enviada.', { position: 'top-right', timeout: 3000 });
      this.$emit('saved', record);
    },
  },
};
</script>

<style>
/* Mesmo padrão dos cards da Revisão de Crédito (esta seção também é usada fora daquela tela). */
.objection-field__label { font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: #757575; margin-bottom: 2px; }
.objection-field__value { font-size: 14px; color: #212121; }
.objection-field__value--amount { font-size: 16px; font-weight: 700; color: #1a237e; }
.objection-field__text { font-size: 14px; color: #424242; white-space: pre-line; text-align: left; }
.analysis-dialog__header { display: flex; align-items: flex-start; gap: 12px; padding: 16px 16px 14px 20px; background: #f5f5f5; }
.analysis-dialog__heading { flex: 1; min-width: 0; }
.analysis-dialog__overline { line-height: 1.4 !important; }
.manifestation-box { border: 1px solid #e3e8f0; background: #f7f9fc; border-radius: 8px; padding: 12px 14px; margin-top: 12px; }
.manifestation-box--pending { border-color: #ffb74d; background: #fff8e1; }
</style>
